var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E7F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2857 41.7143H41.7143V50.2857C41.7143 51.2286 40.9429 52 40 52C39.0571 52 38.2857 51.2286 38.2857 50.2857V41.7143H29.7143C28.7714 41.7143 28 40.9429 28 40C28 39.0571 28.7714 38.2857 29.7143 38.2857H38.2857V29.7143C38.2857 28.7714 39.0571 28 40 28C40.9429 28 41.7143 28.7714 41.7143 29.7143V38.2857H50.2857C51.2286 38.2857 52 39.0571 52 40C52 40.9429 51.2286 41.7143 50.2857 41.7143Z",
    fill: "#3A86FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/AddButton.165bf617.svg";
export { ForwardRef as ReactComponent };